'use strict';

exports.__esModule = true;

var _react = require('react');

var useConstructor = function useConstructor() {
	var callBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

	var _useState = (0, _react.useState)(false),
	    hasBeenCalled = _useState[0],
	    setHasBeenCalled = _useState[1];

	if (hasBeenCalled) return;
	callBack();
	setHasBeenCalled(true);
};

exports.default = { useConstructor: useConstructor };